import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AirlineModel} from '../models/AirlineModel';


const AIRLINES_URL = '/api/airlines';

@Injectable({
    providedIn: 'root'
})
export class AirlinesService {

    constructor(private http: HttpClient) {
    }

    getUsersAirlines(): Observable<AirlineModel[]> {
        return this.http.get<AirlineModel[]>(`${AIRLINES_URL}/me`, {withCredentials: true});
    }

    searchAirlines(search: string): Observable<AirlineModel[]> {
        return this.http.get<AirlineModel[]>(AIRLINES_URL, {params: { search }, withCredentials: true});
    }

    setAirline(airline: number): Observable<void> {
        return this.http.post<any>(`${AIRLINES_URL}/me`, {id: airline}, {withCredentials: true});
    }


    removeAirline(airline: number): Observable<AirlineModel[]> {
        return this.http.delete<AirlineModel[]>(`${AIRLINES_URL}/${airline}`, {withCredentials: true});
    }


}
